import type { FaireProductEntity } from "../../entity_types/product";

export const p_ht4j6wps32: FaireProductEntity = {
  token: "p_ht4j6wps32",
  type: "product",
  name: "Warm Oat Milk Bath Bomb",
  brandToken: "b_68rnwdnrcq",
  brandName: "Salt & Sage Apothecary",
  imageUrl:
    "https://cdn.faire.com/fastly/68c7482be22ad209fb45a8386ff5b6538151292610209c553cdf68b363d0bfdb.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/be13bbc9f4872c424e7f4247ff771518af62ecd68d193b2d5eb85f402ddbb774.png",
    "https://cdn.faire.com/fastly/fbdfde57e44d0e481601a4e08285ab2edbcda6e0f15d09e259920a13e2fb29d3.png",
    "https://cdn.faire.com/fastly/32b8dc0969b552cc83d900b4aa83a86b48c36c462711a6bc539636f2c2e92b7b.png",
    "https://cdn.faire.com/fastly/fb9f231ab72f51baf336cacf1ac65b33ec3f5199d8256a3ea9e02a8cb44c3c85.png",
    "https://cdn.faire.com/fastly/72e574cd2ce05d4a43fe9c60afd85e48d52f1debd0b4bc362e4983df4f0ef219.png",
  ],
  priceDollars: 3.75,
  description:
    "The Warm Oat Milk Bath Bomb is crafted with colloidal oatmeal for a gentle, soothing experience. Perfect for customers with sensitive skin, it offers a nurturing bath that leaves skin soft and comforted. This bath bomb is an ideal addition for boutiques focused on self-care and relaxation.\n\n𝐖𝐡𝐲 𝐑𝐞𝐭𝐚𝐢𝐥𝐞𝐫𝐬 𝐋𝐨𝐯𝐞 𝐈𝐭:\n\n• Gentle on sensitive skin with soothing colloidal oatmeal\n• Warm, comforting aroma that appeals to relaxation seekers\n• Perfect for adding a cozy element to bath and body offerings",
  tags: [],
  msrpDollars: 7.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:49:17.783Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
